import { createApp } from 'vue';

import { createHead } from '@vueuse/head';

import App from './App.vue';
import './css/main.css';

import router from '@/router';
import { i18n } from '@/i18n';
import { store } from '@/store';
import { featureFlags } from '@/modules/FeatureFlags';
import { userTracking } from '@/modules/UserTracking';
import { productTour } from '@/modules/ProductTour';
import { installQueryClient } from '@/modules/QueryClient';

const head = createHead();

export const app = createApp(App)
  .use(i18n)
  .use(store)
  .use(router);

const queryCacheReady = installQueryClient(app);

app
  .use(userTracking)
  .use(featureFlags)
  .use(productTour)
  .use(head);

// Restore persisted query cache before first paint so list views can render cached data.
queryCacheReady.then(() => {
  router.isReady().then(() => app.mount('#app'));
});
